import Grud from './grud.service';

class ProductService extends Grud {
    constructor() {
      super('product');
    }
}
export default ProductService;